import { render, staticRenderFns } from "./PointsTableRow.vue?vue&type=template&id=17986c5b&"
import script from "./PointsTableRow.vue?vue&type=script&lang=ts&"
export * from "./PointsTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports